import actions from './google-recaptcha-v3.actions'
import getters from './google-recaptcha-v3.getters'

export default {
  namespaced: true,
  actions,
  getters,
}
